var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 7.14875L11.8375 9.60875L12.6818 13.2712C12.7265 13.4627 12.7138 13.6631 12.6452 13.8474C12.5766 14.0316 12.4552 14.1916 12.2962 14.3072C12.1372 14.4229 11.9477 14.4891 11.7512 14.4976C11.5548 14.5061 11.3602 14.4565 11.1918 14.355L7.99746 12.4175L4.80996 14.355C4.64157 14.4565 4.447 14.5061 4.25057 14.4976C4.05415 14.4891 3.86459 14.4229 3.70559 14.3072C3.54659 14.1916 3.42521 14.0316 3.35662 13.8474C3.28803 13.6631 3.27528 13.4627 3.31996 13.2712L4.16309 9.6125L1.34372 7.14875C1.1946 7.02014 1.08677 6.85036 1.03375 6.66071C0.980734 6.47107 0.98489 6.26999 1.0457 6.08269C1.10651 5.89539 1.22126 5.73022 1.37556 5.60788C1.52987 5.48554 1.71686 5.41149 1.91309 5.395L5.62934 5.07312L7.07996 1.61312C7.15572 1.43157 7.2835 1.27649 7.44721 1.16741C7.61092 1.05833 7.80324 1.00012 7.99996 1.00012C8.19669 1.00012 8.38901 1.05833 8.55272 1.16741C8.71643 1.27649 8.84421 1.43157 8.91996 1.61312L10.375 5.07312L14.09 5.395C14.2862 5.41149 14.4732 5.48554 14.6275 5.60788C14.7818 5.73022 14.8965 5.89539 14.9574 6.08269C15.0182 6.26999 15.0223 6.47107 14.9693 6.66071C14.9163 6.85036 14.8085 7.02014 14.6593 7.14875H14.6562Z",
    fill: "#F97316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.ec7577c1338cb9b52ddf4f2dd06a5ad5.svg";
export { ForwardRef as ReactComponent };